exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar .navbar-brand a.navbar-item.is-active[data-v-320111c0]{background-color:transparent}", ""]);

// exports
